/**
 * The failure copy slots (components/Failures/spec.md § Cases) in English, keyed by the spec's slot
 * names: the interface catalogue's `failure` entry, which every other language answers key for key.
 */
import {AUTH_ERRORS} from '@core/auth-ui/authErrorCopy'

export const FAILURE_COPY = {
    // Messages
    turnFailed: 'Something went wrong on our side. Your answer is kept.',
    reconnecting: 'Reconnecting…',
    refusalTitle: "Let's take another path",
    refusal: 'Something in your message could not be answered. Try rephrasing, or send it again.',
    openElsewhere: 'This session is also open in another window.',
    serviceDown: 'Quies cannot be reached right now. Nothing you have done is lost.',
    sessionsUsedTitle: 'Your sessions have been used',
    voiceFailedTitle: 'Your meditation is written',
    voiceFailed: 'Its voice could not be made just now. Nothing is lost, and voicing it again costs nothing.',
    voiceStopped: 'The voice stopped partway. It can go on from where it left off.',
    streamMissing: 'Your meditation is ready, but it has not reached this page.',
    tapToListen: 'Tap to listen',
    fileFailed: 'This recording will not play. It can be voiced again from the meditation, at no cost.',
    recordingGone: 'This recording is no longer kept.',
    purchaseCancelled: 'Purchase cancelled. Nothing was charged.',
    purchasePending: 'Your payment is confirmed. Your sessions are taking longer than usual to arrive.',
    checkoutFailed: 'The payment could not be completed. Nothing was charged.',
    sessionEnded: 'This session has come to a close.',
    busy: 'Quies is in high demand just now. Your answer is kept; try again in a minute.',
    tooLong: 'This session has grown longer than Quies can hold. It has been returned to you.',
    notSaved: 'This step could not be kept. Try again to keep your place.',
    meditationRefused: 'This meditation could not be written as asked. Rephrase it, or begin anew: this session will be returned to you.',
    meditationRefusedUncharged: 'This meditation could not be written as asked. Rephrase it, or begin anew.',
    linkExpired: AUTH_ERRORS['link-expired'],
    oauthFailed: AUTH_ERRORS['oauth-failed'],
    offline: "You're offline. Your answer will be sent as soon as you're back.",
    voiceChanged: 'Your voice is no longer available; another voice will speak this meditation.',
    voiceReturned: 'The voice still could not be made. This session has been returned to you.',
    voiceFailedAgain: 'The voice still could not be made.',
    voiceResuming: 'The voice is resuming…',
    voiceLimited: 'Several meditations have been voiced for you this hour. Try again a little later.',

    // Action labels
    tryAgain: 'Try again',
    rephrase: 'Rephrase',
    resume: 'Resume',
    voiceAgain: 'Voice again',
    listen: 'Listen',
    continue: 'Continue',
    begin: 'Begin Session',
    signIn: 'Sign In',
    checkAgain: 'Check again',
    sendLink: 'Email me a sign-in link',
    useEmail: 'Use email instead',
} as const

export type FailureCopyKey = keyof typeof FAILURE_COPY
